import { render, staticRenderFns } from "./config-provider.vue?vue&type=template&id=6d6a8c67&"
import script from "./config-provider.vue?vue&type=script&lang=js&"
export * from "./config-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports